FiltersMdl.controller( 'FamiliesCtrl', [ '$scope', '$state', 'families', 'family', 'HuesSrv', function ( $scope, $state, families, family, HuesSrv ) {

	this.families = families;
	HuesSrv.setFilter('family', family ? family : null );


}]);
